var _style, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125 40",
    style: {
      enableBackground: "new 0 0 125 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#212121;}\r\n\t.st3{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11.617,
    cy: 20,
    r: 11.617
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.617,12.895c-3.924,0-7.105,3.181-7.105,7.105s3.181,7.105,7.105,7.105s7.105-3.181,7.105-7.105 S15.541,12.895,11.617,12.895z M11.617,26.16c-3.402,0-6.16-2.758-6.16-6.16c0-3.402,2.758-6.16,6.16-6.16s6.16,2.758,6.16,6.16 C17.777,23.402,15.019,26.16,11.617,26.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "9.448,23.4 9.448,16.563 15.39,19.967  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "31.503,12.126 29.811,20.153 28.095,12.126 25.517,12.126 28.476,22.91 28.476,28.181 31.077,28.181  31.077,22.956 34.104,12.126  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.164,16.177c-1.548,0-3.729,0.466-3.729,4.942c0,0,0,1.193,0,1.921c0,2.611,0.317,5.259,3.599,5.259 s3.729-2.219,3.729-5.37v-1.287C40.763,19.254,40.614,16.177,37.164,16.177z M38.091,24.494c0,1.206-0.199,2.064-0.991,2.064 c-0.793,0-0.973-1.032-0.973-2.051c0-1.019,0-2.648,0-4.353c0-1.705,0.472-2.161,0.973-2.161c0.96,0,0.991,1.33,0.991,2.039 C38.091,20.74,38.091,23.288,38.091,24.494z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M46.637,25.725c0,0-0.28,0.758-1.125,0.758c-0.584,0-0.758-0.559-0.758-1.343 c0-0.783,0.019-8.721,0.019-8.721h-2.648c0,0,0,6.769,0,8.485c0,1.716,0.242,3.394,2.256,3.394c2.014,0,2.592-1.66,2.592-1.66 l0.261,1.542h2.033V16.42h-2.629V25.725z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.175,25.725c0,0-0.28,0.758-1.125,0.758c-0.584,0-0.758-0.559-0.758-1.343 c0-0.783,0.019-8.721,0.019-8.721h-2.648c0,0,0,6.769,0,8.485c0,1.716,0.242,3.394,2.256,3.394s2.592-1.66,2.592-1.66l0.261,1.542 h2.033V16.42h-2.629V25.725z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M101.722,25.725c0,0-0.28,0.758-1.125,0.758c-0.584,0-0.74-0.559-0.74-1.343c0-0.783,0-8.721,0-8.721h-2.648 c0,0,0,6.769,0,8.485c0,1.716,0.242,3.394,2.256,3.394c2.014,0,2.592-1.66,2.592-1.66l0.261,1.542h2.033V16.42h-2.629V25.725z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "56.446,12.126 48.633,12.126 48.633,14.219 51.225,14.219 51.225,28.181 53.835,28.181  53.835,14.219 56.446,14.219  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.368,16.196c-1.148,0-1.991,0.729-2.461,1.617v-6.323h-2.536v16.69h2.213l0.289-1.197 c0,0,0.705,1.314,2.29,1.314s2.629-1.268,2.629-4.736c0,0,0.065-2.545,0-2.611C71.793,18.564,71.494,16.196,69.368,16.196z  M69.145,23.537c0,2.561-0.559,2.909-1.169,2.909c-0.609,0-1.019-0.584-1.019-0.584v-6.713c0.062-0.423,0.646-1.094,1.14-1.094 c0.928,0,1.048,1.181,1.048,2.921C69.145,21.361,69.145,22.008,69.145,23.537z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M76.516,16.177c-1.481,0-3.569,0.466-3.569,4.942c0,0,0,1.193,0,1.921c0,2.611,0.303,5.259,3.444,5.259 c2.508,0,3.569-1.193,3.498-3.589c-0.002-0.059-2.316-0.178-2.316-0.178c-0.002,1.183-0.098,2.026-1.025,2.026 c-0.939,0-1.025-1.032-1.025-2.051c0-0.374,0-0.831,0-1.343h4.433l0.004-1.542C79.961,19.238,80.067,16.177,76.516,16.177z  M75.523,21.622c0-0.474,0-0.968,0-1.469c0-1.705,0.285-2.174,0.966-2.174c1.119,0,0.984,1.343,0.984,2.051 c0,0.292,0.017,0.897,0.037,1.591H75.523z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.713,23.798c0.062,1.927-0.273,2.76-1.003,2.76s-0.936-0.696-0.936-2.026c0-0.472,0-2.511,0-4.326 c0-1.815,0.361-2.225,0.895-2.225c0.858,0,0.97,1.007,0.97,1.988c0,0.272,0,0.897,0,0.897l2.275-0.162 c0.236-3.543-1.007-4.525-3.235-4.525c-1.481,0-3.569,0.466-3.569,4.942c0,0,0,1.193,0,1.921c0,2.611,0.303,5.259,3.444,5.259 c3.315,0,3.447-2.076,3.447-4.364L122.713,23.798z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.844,16.73c-0.296,1.502-1.034,5.32-1.281,7.906h-0.197c-0.049-2.266-2.171-12.51-2.171-12.51h-3.733 v16.055h2.308V14.932l2.562,13.249h2.291l2.562-13.175v13.175h2.315V12.126h-3.695C91.804,12.126,91.139,15.227,90.844,16.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M109.896,21.349c-1.206-0.945-1.79-1.305-1.79-2.325c0-0.584,0.35-0.97,1.064-0.97 c0.627,0,1.007,0.353,1.004,2.253l2.212-0.089c0,0,0.013-0.946-0.089-1.752c-0.102-0.805-0.626-2.25-3.119-2.25 c-1.675,0-3.35,0.588-3.35,3.119c0,1.828,0.933,2.698,2.685,4.078c1.419,1.074,1.758,1.54,1.758,2.112s-0.273,1.069-1.069,1.069 c-0.796,0-1.218-0.82-1.131-2.051l-2.242,0.012c0,0-0.107,1.442,0.191,2.2c0.298,0.758,0.962,1.629,3.079,1.629 s3.435-0.908,3.435-3.12C112.531,23.052,111.101,22.294,109.896,21.349z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.973,
    y: 16.42,
    className: "st2",
    width: 2.499,
    height: 11.692
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M115.559,11.796h-0.545c-0.63,0-1.141,0.511-1.141,1.141v0.945c0,0.63,0.511,1.141,1.141,1.141h0.545 c0.63,0,1.141-0.511,1.141-1.141v-0.945C116.699,12.307,116.189,11.796,115.559,11.796z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st3",
    width: 125,
    height: 40
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeMusic);
export default __webpack_public_path__ + "static/media/youtubeMusic.5f67e6685f35a159558d951c2a39a387.svg";
export { ForwardRef as ReactComponent };